export default __webpack_public_path__ + "img/service_DS3.eff1c292d27e2f4c23551e34bc567414.jpg";